/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_Write_OnlyInputs */

const cs_ebr_conn_write_only = /** @type {(inputs: Ebr_Conn_Write_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresa je soukromá – uloží se šifrovaně a už se nezobrazí (jen zkrácený název hostitele).`)
};

const en_ebr_conn_write_only = /** @type {(inputs: Ebr_Conn_Write_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The address is private – stored encrypted and never shown again (only a short host hint).`)
};

/**
* | output |
* | --- |
* | "The address is private – stored encrypted and never shown again (only a short host hint)." |
*
* @param {Ebr_Conn_Write_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_write_only = /** @type {((inputs?: Ebr_Conn_Write_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Write_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_write_only(inputs)
	return cs_ebr_conn_write_only(inputs)
});